import { ExperienceStatus } from '@utriper/core';
import { fetch, Method } from '../fetch';

const SearchRoutes = {
    searchExperiences: (params) => `/api/v2.0/experience/search?${params}`,
    searchBundles: (params) => `/api/v2.0/bundle/search?${params}`,
};

export const SearchService = {
    searchExperiences: async (options) => {
        try {
            const params = new URLSearchParams();

            if (options?.name?.length > 0) {
                params.append('name', options.name);
            }

            if (options?.experiencerId) {
                params.append('experiencerId', options.experiencerId);
            }

            if (options?.contractId) {
                params.append('code', options.contractId?.toString(16));
            }

            if (options?.targetCurrency) {
                params.append('targetCurrency', options.targetCurrency);
            }

            if (options?.cursor) {
                params.append('cursor', options.cursor);
            }

            params.append('status', ExperienceStatus.IDS.live);

            const { data } = await fetch(SearchRoutes.searchExperiences(params.toString()), {
                method: Method.GET,
                authenticated: true,
            });

            return data || {};
        } catch (error) {
            throw error;
        }
    },
    searchBundles: async (options) => {
        try {
            if (!options?.contractId) return [];

            const params = new URLSearchParams();

            if (options?.name?.length > 0) {
                params.append('name', options.name);
            }

            if (options?.contractId) {
                params.append('code', options.contractId?.toString(16));
            }

            if (options?.targetCurrency) {
                params.append('targetCurrency', options.targetCurrency);
            }

            if (options?.cursor) {
                params.append('cursor', options.cursor);
            }

            const { data } = await fetch(SearchRoutes.searchBundles(params.toString()), {
                method: Method.GET,
                authenticated: true,
            });

            return data || {};
        } catch (error) {
            throw error;
        }
    },
};
